export default {
  methods: {
    async fetchJobs() {
      const endpoint =
        'https://boards-api.greenhouse.io/v1/boards/tribal/offices/90146/'
      const response = await fetch(endpoint)
      const data = await response.json()

      return data
    },

    async fetchJobById(id) {
      if (!id) {
        return
      }

      const endpoint = `https://boards-api.greenhouse.io/v1/boards/tribal/jobs/${id}/`
      const response = await fetch(endpoint)
      const data = await response.json()

      return data
    },
  },
}
